/**
 * Component for each tool / technology.
 * @param {String} link External link to tools documentation / website.
 * @param {String} name Name of tool.
 * @param {any} logo Imported image, preferably .webp.
 */
export default function Tool({ link, name, logo, lowPriority, bgStyle }) {
    return (
        <a href={link}
            data-aos="fade-up" data-aos-duration="600" data-toggle="tooltip" data-placement="top"
            target="_blank" rel="noreferrer"
            aria-label={`${name} website (opens in a new tab)`}
            className={`tool-item ${lowPriority ? 'desktop-only' : ''}`}
            title={name} >
            <div className={`logo${logo ? '' : ' tool-name'}`} style={logo ? { backgroundImage: `url('${logo}')`, ...bgStyle } : undefined}>
                {!logo && name}
            </div>
        </a>
    )
}
